/** @prettier */
import React from "react";
import { ChartConfiguration } from "chart.js";
import { Label } from "react-bootstrap";
import "./ScoreWidget.css";

export const calcPercentage = (count: number, total: number, places = 0) =>
    ((count * 100) / total).toFixed(places);

type ChartConfigData = {
    value: number;
    label: string;
    color: string;
};
export const buildChartConfig = (
    type: "pie" | "doughnut",
    _data: Array<ChartConfigData>,
): ChartConfiguration => {
    // Sort the data from biggest percentage to smallest,
    // it makes the graph look nicer
    const data = _data.slice();
    data.sort((d1, d2) => d2.value - d1.value);
    return {
        type,
        data: {
            datasets: [
                {
                    data: data.map(({ value }) => value),
                    backgroundColor: data.map(({ color }) => color),
                },
            ],
            labels: data.map(({ label }) => label),
        },
        options: {
            aspectRatio: 1,
            legend: {
                display: false,
            },
            cutoutPercentage: type === "pie" ? 0 : 65,
        },
    };
};

export type ScoreBreakdownItemProps = {
    label: string;
    labelStyle: string;
    count: number;
    total: number;
};
export const ScoreBreakdownItem = ({
    label,
    labelStyle,
    count,
    total,
}: ScoreBreakdownItemProps) => (
    <div>
        <Label bsStyle={labelStyle}>{label}</Label>{" "}
        <span className="score-widget-breakdown-text">
            {count} of {total} ({calcPercentage(count, total)}%)
        </span>
    </div>
);
